<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content class="error-dialog-content">
  <div class="alert" [class.alert-danger]="data.isError !== false" [class.alert-success]="data.isError === false">
    {{ data.message }}
  </div>

  <div class="soap-code-block" *ngIf="data.envelope">
    <p class="soap-code-label">SOAP-Request</p>
    <pre class="soap-code-body">{{ data.envelope }}</pre>
  </div>

  <div class="soap-code-block">
    <p class="soap-code-label">Response Body</p>
    <pre class="soap-code-body">{{ data.responseBody || '(keine Antwort vom Server)' }}</pre>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button" class="btn btn-primary" (click)="close()">OK</button>
</mat-dialog-actions>
